// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3HCVZ","rootCenter":"LoadMoreObserver_rootCenter__2hB4a","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2JHHC"};